import React from 'react';

export default class Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToMakeComplexIdeasSimpleClearAndConcise');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Consider a role model</div>
                                            <p>Try and identify someone you know who you admire for their
                                                ability to break difficult things down
                                                into easy manageable parts. Think about what it is you like
                                                about their approach and what works
                                                well for them. Then consider how you can adapt your style.
                                                This is the starting point for you to
                                                develop a plan to improve – see below.</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Watch out for opportunities in your current work or elsewhere
                                                to practise taking something
                                                complex and trying to simplify the problem using the
                                                information you have picked up from this
                                                tool.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use this tool to write out a personal, focused development
                                                plan on how you will make complex
                                                things more simple.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Further Information
                                            </div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToReframeProblems')}>How
                                                        to reframe problems</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToPrioritiseTasksReadyForAction')}>How
                                                        to prioritise tasks ready for action</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToFormulateActionPlans')}>How
                                                        to formulate action plans</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToCommunicateYourVision')}>How
                                                        to communicate your vision.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad sept"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> der Waldt, V., la
                                                    Rey, D., De Beer, N., &amp; Du Plessis, N. (2007).
                                                    Attitudes towards attractive and credible
                                                    celebrities in advertisements: a survey amongst
                                                    students.</p></li>
                                                <li><p className="further_info_content"> Wurman, R. S.
                                                    (1997). What’s an Information Architect?.</p></li>

                                                <li><p className="further_info_content"> Myers, I. B.
                                                    (1962). <span className="subtiltereg">  The Myers-Briggs type indicator. </span> Palo
                                                    Alto, CA: Consulting Psychologists Press.</p></li>
                                                <li><p className="further_info_content"><a
                                                    href="http://www.sempervitainstitute.com/2012/01/s-to-n-thats-not-data-.html"
                                                    className="link_color thought"> http://www.sempervitainstitute.com/2012/01/s-to-n-thats-not-data-.html</a>
                                                </p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}